export default __webpack_public_path__ + "static/media/familyrain.211afdd1.jpg";